import getCurrentSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import isItemView from 'owa-mail-store/lib/utils/isItemView';
import { getMailSearchStore } from '../store/Store';
import { Mini3SScenario } from 'mini-3s-service/lib/schema/SubstrateScenarios';
import { ResultsView } from 'mini-3s-telemetry/lib/schema/ResultsView';
import { signalWorkflowEvent } from 'mini-workflow-manager';
import { SubstrateEntityType } from 'mini-3s-service/lib/schema/SubstrateEntityType';
import { SubstrateSignalType } from 'mini-3s-telemetry/lib/schema/SubstrateSignalType';
import { SubstrateTelemetryEvent } from 'mini-3s-telemetry/lib/schema/SubstrateTelemetryEvent';
import {
    LayoutType,
    PlacementType,
    ResultType,
} from 'mini-3s-telemetry/lib/schema/SubstrateSearchLogTypes';

/**
 * Utility function which prepares meta data for logging
 * clientLayout event for Mail results
 * @param logicalId  Logical Id associated with result set
 */
export function logMailResultsView(logicalId: string) {
    const currentTableView = getCurrentSelectedTableView();
    const { searchResultsItemIdToReferenceIdMap } = getMailSearchStore();
    const entityType = isItemView()
        ? SubstrateEntityType.Message
        : SubstrateEntityType.Conversation;

    if (!currentTableView?.itemIds?.length) {
        return;
    }

    const mailResultsView: ResultsView[] = [
        {
            layoutType: LayoutType.Vertical,
            type: ResultType.Group,
            name: entityType,
            position: 1,
            resultsView: currentTableView?.itemIds?.map((itemId, index) => {
                const instrumentationContext = searchResultsItemIdToReferenceIdMap.get(itemId);
                return {
                    entityType: entityType,
                    referenceId: instrumentationContext?.referenceId,
                    providerId: instrumentationContext?.traceId,
                    position: index + 1,
                    type: ResultType.Entity,
                    placementType: PlacementType.Visible,
                };
            }),
        },
    ];

    signalWorkflowEvent(
        SubstrateTelemetryEvent.ClientLayout,
        {
            logicalId,
            layOutType: LayoutType.Vertical,
            resultsView: JSON.stringify(mailResultsView),
            scenario: Mini3SScenario.MINI_SEARCH_SCENARIO_NAME,
        },
        { signalType: SubstrateSignalType.LogEvent }
    );
}
